export const HIDDEN_COUNTRIES = ['HK', 'GB'];